export default `:host([enable-container][hide-down=xs]),
.enable-container[hide-down=xs] {
  display: block;
}
@container (max-width: 320px) {
  :host([enable-container][hide-down=xs]),
  .enable-container[hide-down=xs] {
    display: none;
  }
}

:host([enable-container][hide-down=sm]),
.enable-container[hide-down=sm] {
  display: block;
}
@container (max-width: 767px) {
  :host([enable-container][hide-down=sm]),
  .enable-container[hide-down=sm] {
    display: none;
  }
}

:host([enable-container][hide-down=md]),
.enable-container[hide-down=md] {
  display: block;
}
@container (max-width: 927px) {
  :host([enable-container][hide-down=md]),
  .enable-container[hide-down=md] {
    display: none;
  }
}

:host([enable-container][hide-down=lg]),
.enable-container[hide-down=lg] {
  display: block;
}
@container (max-width: 928px) {
  :host([enable-container][hide-down=lg]),
  .enable-container[hide-down=lg] {
    display: none;
  }
}

:host([enable-container][hide-down=xl]),
.enable-container[hide-down=xl] {
  display: block;
}
@container (max-width: 1183px) {
  :host([enable-container][hide-down=xl]),
  .enable-container[hide-down=xl] {
    display: none;
  }
}

:host([enable-container][hide-down=xxl]),
.enable-container[hide-down=xxl] {
  display: block;
}
@container (max-width: 2463px) {
  :host([enable-container][hide-down=xxl]),
  .enable-container[hide-down=xxl] {
    display: none;
  }
}

:host([enable-container][hide-up=xs]),
.enable-container[hide-up=xs] {
  display: block;
}
@container (min-width: 320px) {
  :host([enable-container][hide-up=xs]),
  .enable-container[hide-up=xs] {
    display: none;
  }
}

:host([enable-container][hide-up=sm]),
.enable-container[hide-up=sm] {
  display: block;
}
@container (min-width: 767px) {
  :host([enable-container][hide-up=sm]),
  .enable-container[hide-up=sm] {
    display: none;
  }
}

:host([enable-container][hide-up=md]),
.enable-container[hide-up=md] {
  display: block;
}
@container (min-width: 927px) {
  :host([enable-container][hide-up=md]),
  .enable-container[hide-up=md] {
    display: none;
  }
}

:host([enable-container][hide-up=lg]),
.enable-container[hide-up=lg] {
  display: block;
}
@container (min-width: 928px) {
  :host([enable-container][hide-up=lg]),
  .enable-container[hide-up=lg] {
    display: none;
  }
}

:host([enable-container][hide-up=xl]),
.enable-container[hide-up=xl] {
  display: block;
}
@container (min-width: 1183px) {
  :host([enable-container][hide-up=xl]),
  .enable-container[hide-up=xl] {
    display: none;
  }
}

:host([enable-container][hide-up=xxl]),
.enable-container[hide-up=xxl] {
  display: block;
}
@container (min-width: 2463px) {
  :host([enable-container][hide-up=xxl]),
  .enable-container[hide-up=xxl] {
    display: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
